import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Dropdown from '../Dropdown';
import { getTranslation } from '../../providers/TranslationProvider';
import './DateInput.scss';

const BLANK = 'BLANK';

export const EMPTY_DATE = 'BLANK-BLANK-BLANK';
export const INCOMPLETE_DATE = 'INCOMPLETE_DATE';
export const dateToApiDate = (prevDateOfBirth, dateOfBirth) => {
  const hasBlanks = dateOfBirth !== EMPTY_DATE && dateOfBirth.includes('BLANK');
  if (prevDateOfBirth === EMPTY_DATE && dateOfBirth === EMPTY_DATE) return '';
  if (hasBlanks) return INCOMPLETE_DATE;
  return dateOfBirth;
};
const padZero = (num) => (num < 10 ? '0' : '') + num;

const getMonthOptions = () => {
  const MONTH_OPTIONS = [];
  const MONTH_LABELS = moment().localeData().months();
  const translatedMonths = [];
  MONTH_LABELS.forEach((month) => {
    translatedMonths.push(getTranslation({
      translationKey: `months.${month}`,
      fallback: month,
    }));
  });

  MONTH_OPTIONS.push({
    key: BLANK,
    value: BLANK,
    label: (window.translationMap || {}).month || 'Month',
  });
  for (let i = 0; i < 12; i += 1) {
    const str = padZero(i + 1);
    const label = translatedMonths[i];
    MONTH_OPTIONS.push({ key: str, value: str, label });
  }
  return MONTH_OPTIONS;
};

const getDayOptions = () => {
  const DAY_OPTIONS = [];
  const numDays = 31;
  DAY_OPTIONS.push({
    key: BLANK,
    value: BLANK,
    label: (window.translationMap || {}).day || 'Day',
  });
  for (let day = 1; day <= numDays; day += 1) {
    const key = day;
    const str = padZero(day);
    DAY_OPTIONS.push({ key, value: str, label: str });
  }
  return DAY_OPTIONS;
};

const getYearOptions = () => {
  const YEAR_OPTIONS = [];
  const MAX_YEAR = Math.max(2019, (new Date()).getFullYear());
  const MIN_YEAR = 1900;
  YEAR_OPTIONS.push({
    key: BLANK,
    value: BLANK,
    label: (window.translationMap || {}).year || 'Year',
  });
  for (let year = MAX_YEAR; year >= MIN_YEAR; year -= 1) {
    const str = `${year}`;
    YEAR_OPTIONS.push({ key: str, value: str, label: str });
  }
  return YEAR_OPTIONS;
};

const DateInput = ({ value, onChange }) => {
  const dateParts = value;
  const [year, month, day] = dateParts;
  const format = moment.localeData().longDateFormat('L');
  const dateComponents = [
    <Dropdown
      key="month"
      name="DateInput__month"
      options={getMonthOptions()}
      selected={`${month}`}
      onChange={({ DateInput__month: nextMonth }) => {
        onChange([year, nextMonth, day]);
      }}
    />,
    <Dropdown
      key="day"
      name="DateInput__day"
      options={getDayOptions(year, month)}
      selected={`${day}`}
      onChange={({ DateInput__day: nextDay }) => {
        onChange([year, month, nextDay]);
      }}
    />,
    <Dropdown
      key="year"
      name="DateInput__year"
      options={getYearOptions()}
      selected={`${year}`}
      onChange={({ DateInput__year: nextYear }) => {
        onChange([nextYear, month, day]);
      }}
    />,
  ];
  const dateLocaleOrder = format.split(/[/. -]/g).map((part) => {
    if (part.includes('M')) return dateComponents[0];
    if (part.includes('D')) return dateComponents[1];
    if (part.includes('Y')) return dateComponents[2];
    return null;
  });

  return (
    <div className="DateInput">
      {dateLocaleOrder.some((n) => n === null) ? dateComponents : dateLocaleOrder}
    </div>
  );
};

DateInput.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DateInput;
